import PropTypes from 'prop-types'
import React from 'react'
import ProgressBar from '../ProgressBar'
import passportImg from '../../assets/img/passportLogo.svg'

class VideoItemThumb extends React.Component {
  constructor(props) {
    super(props)

    let placeholderIsShow = false
    if (props.itemType === 'show') {
      placeholderIsShow = true
    }

    this.state = {
      thumbnailLoaded: false,
      placeholderIsShow,
      imageError: false,
    }
  }

  imgError(image) {
    image.persist()
    // TODO: re-visit if we want to track missing images
    // Sentry.captureException('ImageError', {
    //   extra: { image: this.state.image },
    // })
    this.setState({ imageError: true })
  }

  render() {
    const {
      itemType,
      title,
      focus,
      is_mvod,
      currentlyWatched,
      videoLength,
      emptySet,
    } = this.props

    let thumb = this.props.thumb

    if (this.state.imageError) {
      thumb = null
    }
    let hasImage = true
    if (thumb === null) {
      hasImage = false
    }
    let shouldDisplayTitle =
      !hasImage && itemType !== 'season' && itemType !== 'skylab-collection'

    return (
      <>
        <div
          className={`video-item-thumb-background image-${hasImage} 
          ${emptySet ? 'empty-set' : ''} ${focus ? 'focused' : ''}`}
          style={{
            width:
              itemType === 'video' || itemType === 'season'
                ? '487px'
                : itemType === 'showcase'
                ? '633px'
                : itemType === 'show'
                ? '260px'
                : '487px',
            height:
              itemType === 'video' || itemType === 'season'
                ? '274px'
                : itemType === 'showcase'
                ? '356px'
                : itemType === 'show'
                ? '390px'
                : '274px',
          }}
        >
          {hasImage ? (
            <img
              className="thumbnail"
              src={thumb}
              onError={(e) => this.imgError(e)}
              alt={`${title} show poster`}
              style={{
                width:
                  itemType === 'show'
                    ? '260px'
                    : itemType === 'showcase'
                    ? '633px'
                    : '487px',
                height:
                  itemType === 'show'
                    ? '390px'
                    : itemType === 'showcase'
                    ? '356px'
                    : '274px',
              }}
            />
          ) : null}
          {shouldDisplayTitle && (
            <div className="title-container">
              <span className="title">{title}</span>
            </div>
          )}

          {'season' === itemType && <div className="season-overlay" />}
          {'skylab-collection' === itemType && (
            <div className="collections-overlay" />
          )}

          {true === is_mvod && (
            <div className="passport-triangle">
              <img
                className="passport-logo"
                src={passportImg}
                alt={'passport logo'}
              />
            </div>
          )}
          {currentlyWatched > 0 && (
            <ProgressBar current={currentlyWatched} total={videoLength} />
          )}
        </div>
      </>
    )
  }
}

VideoItemThumb.propTypes = {
  currentlyWatched: PropTypes.number,
  focus: PropTypes.bool,
  is_mvod: PropTypes.bool,
  itemType: PropTypes.string,
  thumb: PropTypes.string,
  title: PropTypes.string,
  videoLength: PropTypes.number,
  emptySet: PropTypes.bool,
}

export default VideoItemThumb
